import type React from 'react';

/** @deprecated Use icons from icons-v2-generated instead. */
export interface ServerIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

/** @deprecated Use icons from icons-v2-generated instead. */
export function ServerIcon({ className, color = 'white', ...props }: ServerIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M20.8745 14.9995C20.8742 13.9642 20.0349 13.1245 18.9995 13.1245H5C3.96463 13.1245 3.12526 13.9642 3.125 14.9995V17.0005C3.12526 18.0358 3.96463 18.8755 5 18.8755H18.9995C20.0349 18.8755 20.8742 18.0358 20.8745 17.0005V14.9995ZM20.8745 7C20.8745 5.96447 20.035 5.125 18.9995 5.125H5C3.96447 5.125 3.125 5.96447 3.125 7V8.99951C3.125 10.035 3.96447 10.8745 5 10.8745H18.9995L19.1914 10.8657C20.137 10.7699 20.8745 9.97044 20.8745 8.99951V7ZM23.1245 8.99951C23.1245 10.183 22.6235 11.2473 21.8252 11.9995C22.6237 12.7517 23.1244 13.816 23.1245 14.9995V17.0005C23.1242 19.2784 21.2775 21.1255 18.9995 21.1255H5C2.72199 21.1255 0.875264 19.2784 0.875 17.0005V14.9995C0.875137 13.8161 1.37595 12.7516 2.17432 11.9995C1.37612 11.2473 0.875 10.1829 0.875 8.99951V7C0.875 4.72183 2.72183 2.875 5 2.875H18.9995C21.2777 2.875 23.1245 4.72183 23.1245 7V8.99951Z"
        fill={color}
      />
      <path
        d="M10.0005 14.875L10.1147 14.8809C10.6822 14.9383 11.1255 15.4174 11.1255 16C11.1255 16.5826 10.6822 17.0617 10.1147 17.1191L10.0005 17.125H6C5.37868 17.125 4.875 16.6213 4.875 16C4.875 15.3787 5.37868 14.875 6 14.875H10.0005ZM10.0005 6.87549L10.1147 6.88135C10.6821 6.93886 11.1255 7.41792 11.1255 8.00049C11.1252 8.58286 10.682 9.06218 10.1147 9.11963L10.0005 9.12549H6C5.37884 9.12549 4.87526 8.62158 4.875 8.00049C4.875 7.37917 5.37868 6.87549 6 6.87549H10.0005ZM19.3755 16C19.3755 16.7594 18.7594 17.3755 18 17.3755C17.2881 17.3755 16.7023 16.834 16.6318 16.1406L16.6245 16L16.6318 15.8594C16.7023 15.166 17.2881 14.6245 18 14.6245L18.1406 14.6318C18.834 14.7023 19.3755 15.2881 19.3755 16ZM19.3755 8.00049C19.3752 8.75966 18.7592 9.37451 18 9.37451C17.2882 9.37451 16.7025 8.83423 16.6318 8.14111L16.6245 8.00049L16.6318 7.85986C16.702 7.16629 17.2879 6.625 18 6.625C18.7594 6.625 19.3755 7.2411 19.3755 8.00049Z"
        fill={color}
      />
    </svg>
  );
}
